import axios from 'axios';
import config from './config';

const API_BASE_URL = config.API_BASE_URL;

export const fetchBranches = async () => {
  const response = await axios.get(`${API_BASE_URL}/Branches`);
  return response.data.map((item) => ({
    id: item.id || item.Id,
    name: item.name || item.Name,
    address: item.address || item.Address,
    latitude: item.latitude || item.Latitude,
    longitude: item.longitude || item.Longitude,
    
    // Delivery settings
    DeliveryRangeKm: item.DeliveryRangeKm || item.deliveryRangeKm || 10,
    deliveryRangeKm: item.deliveryRangeKm || item.DeliveryRangeKm || 10,
    deliveryFeeType: item.deliveryFeeType || item.deliveryfeetype || 'fixedAmount',
    deliveryfeetype: item.deliveryfeetype || item.deliveryFeeType || 'fixedAmount',
    deliveryFeeValue: item.deliveryFeeValue || item.deliveryfeevalue || 0,
    deliveryfeevalue: item.deliveryfeevalue || item.deliveryFeeValue || 0,
    
    // Opening hours
    isActive: item.isActive ?? item.IsActive ?? true,
    openingTime: item.openingTime || item.OpeningTime,
    closingTime: item.closingTime || item.ClosingTime,
    
    // Images
    ImageUrl: item.ImageUrl || item.imageUrl || item.Image || item.image || '',
    imageUrl: item.imageUrl || item.ImageUrl || item.Image || item.image || '',
    Image: item.Image || item.image || item.ImageUrl || item.imageUrl || '',
    image: item.image || item.Image || item.ImageUrl || item.imageUrl || '',
    
    // Social Media
    facebookUrl: item.facebookUrl || item.FacebookUrl || item.facebook || item.Facebook || '',
    FacebookUrl: item.FacebookUrl || item.facebookUrl || item.facebook || item.Facebook || '',
    instagramUrl: item.instagramUrl || item.InstagramUrl || item.instagram || item.Instagram || '',
    InstagramUrl: item.InstagramUrl || item.instagramUrl || item.instagram || item.Instagram || '',
    
    Filters: item.Filters || item.filters || [],
    description: item.description || item.Description || '',
    Description: item.Description || item.description || '',
    phoneNumber: item.phoneNumber || item.PhoneNumber || '',
    PhoneNumber: item.PhoneNumber || item.phoneNumber || '',

    // ✅ NEW: Display Order & Featured
    displayOrder: item.DisplayOrder ?? item.displayOrder ?? 999999,
    DisplayOrder: item.DisplayOrder ?? item.displayOrder ?? 999999,
    isFeatured: item.IsFeatured ?? item.isFeatured ?? false,
    IsFeatured: item.IsFeatured ?? item.isFeatured ?? false,

    // ✅ NEW: Rating stats
    averageRating: item.AverageRating ?? item.averageRating ?? 0,
    AverageRating: item.AverageRating ?? item.averageRating ?? 0,
    totalRatings: item.TotalRatings ?? item.totalRatings ?? 0,
    TotalRatings: item.TotalRatings ?? item.totalRatings ?? 0,

    // ✅ NEW: Like stats
    totalLikes: item.TotalLikes ?? item.totalLikes ?? 0,
    TotalLikes: item.TotalLikes ?? item.totalLikes ?? 0,
    totalDislikes: item.TotalDislikes ?? item.totalDislikes ?? 0,
    TotalDislikes: item.TotalDislikes ?? item.totalDislikes ?? 0,

    // ✅ NEW: Delivery Cities (included in findAll response)
    DeliveryCities: item.DeliveryCities || item.deliveryCities || [],
    deliveryCities: item.deliveryCities || item.DeliveryCities || [],

    // ✅ NEW: Connected Branches (included in findAll response)
    ConnectedBranches: item.ConnectedBranches || item.connectedBranches || [],
    connectedBranches: item.connectedBranches || item.ConnectedBranches || [],
  }));
};

export const createBranch = async (branchData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/Branches`, branchData);
    return response.data;
  } catch (error) {
    console.error('Error creating branch:', error);
    throw error;
  }
};

export const fetchBranchById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/Branches/${id}`);
  const item = response.data;
  return {
    id: item.id || item.Id,
    name: item.name || item.Name,
    address: item.address || item.Address,
    latitude: item.latitude || item.Latitude,
    longitude: item.longitude || item.Longitude,
    
    // Delivery settings
    DeliveryRangeKm: item.DeliveryRangeKm || item.deliveryRangeKm || 10,
    deliveryRangeKm: item.deliveryRangeKm || item.DeliveryRangeKm || 10,
    deliveryFeeType: item.deliveryFeeType || item.deliveryfeetype || 'fixedAmount',
    deliveryfeetype: item.deliveryfeetype || item.deliveryFeeType || 'fixedAmount',
    deliveryFeeValue: item.deliveryFeeValue || item.deliveryfeevalue || 0,
    deliveryfeevalue: item.deliveryfeevalue || item.deliveryFeeValue || 0,
    
    // Opening hours
    isActive: item.isActive ?? item.IsActive ?? true,
    openingTime: item.openingTime || item.OpeningTime,
    closingTime: item.closingTime || item.ClosingTime,
    
    // Images
    ImageUrl: item.ImageUrl || item.imageUrl || item.Image || item.image || '',
    imageUrl: item.imageUrl || item.ImageUrl || item.Image || item.image || '',
    Image: item.Image || item.image || item.ImageUrl || item.imageUrl || '',
    image: item.image || item.Image || item.ImageUrl || item.imageUrl || '',
    
    // Social Media
    facebookUrl: item.facebookUrl || item.FacebookUrl || item.facebook || item.Facebook || '',
    FacebookUrl: item.FacebookUrl || item.facebookUrl || item.facebook || item.Facebook || '',
    instagramUrl: item.instagramUrl || item.InstagramUrl || item.instagram || item.Instagram || '',
    InstagramUrl: item.InstagramUrl || item.instagramUrl || item.instagram || item.Instagram || '',
    
    description: item.description || item.Description || '',
    Description: item.Description || item.description || '',
    phoneNumber: item.phoneNumber || item.PhoneNumber || '',
    PhoneNumber: item.PhoneNumber || item.phoneNumber || '',

    // ✅ NEW: Filters
    Filters: item.Filters || item.filters || [],
    filters: item.filters || item.Filters || [],

    // ✅ NEW: Display Order & Featured
    displayOrder: item.DisplayOrder ?? item.displayOrder ?? 999999,
    DisplayOrder: item.DisplayOrder ?? item.displayOrder ?? 999999,
    isFeatured: item.IsFeatured ?? item.isFeatured ?? false,
    IsFeatured: item.IsFeatured ?? item.isFeatured ?? false,

    // ✅ NEW: Rating stats
    averageRating: item.AverageRating ?? item.averageRating ?? 0,
    AverageRating: item.AverageRating ?? item.averageRating ?? 0,
    totalRatings: item.TotalRatings ?? item.totalRatings ?? 0,
    TotalRatings: item.TotalRatings ?? item.totalRatings ?? 0,

    // ✅ NEW: Like stats
    totalLikes: item.TotalLikes ?? item.totalLikes ?? 0,
    TotalLikes: item.TotalLikes ?? item.totalLikes ?? 0,
    totalDislikes: item.TotalDislikes ?? item.totalDislikes ?? 0,
    TotalDislikes: item.TotalDislikes ?? item.totalDislikes ?? 0,

    // ✅ NEW: Delivery Cities
    DeliveryCities: item.DeliveryCities || item.deliveryCities || [],
    deliveryCities: item.deliveryCities || item.DeliveryCities || [],

    // ✅ NEW: Connected Branches
    ConnectedBranches: item.ConnectedBranches || item.connectedBranches || [],
    connectedBranches: item.connectedBranches || item.ConnectedBranches || [],

    // ✅ NEW: Recent Ratings (only from findOne)
    RecentRatings: item.RecentRatings || item.recentRatings || [],
    recentRatings: item.recentRatings || item.RecentRatings || [],
  };
};

// ✅ Get delivery cities for a branch
export const fetchBranchCities = async (branchId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/Branches/${branchId}/cities`);
    return response.data;
  } catch (error) {
    console.error('Error fetching branch cities:', error);
    throw error;
  }
};

// ==================== 🆕 FEATURED BRANCHES ====================

export const fetchFeaturedBranches = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/Branches/featured`);
    return response.data.map((item) => ({
      id: item.id || item.Id,
      name: item.name || item.Name,
      address: item.address || item.Address,
      latitude: item.latitude || item.Latitude,
      longitude: item.longitude || item.Longitude,

      // Delivery settings
      DeliveryRangeKm: item.DeliveryRangeKm || item.deliveryRangeKm || 10,
      deliveryRangeKm: item.deliveryRangeKm || item.DeliveryRangeKm || 10,
      deliveryFeeType: item.deliveryFeeType || item.deliveryfeetype || 'fixedAmount',
      deliveryfeetype: item.deliveryfeetype || item.deliveryFeeType || 'fixedAmount',
      deliveryFeeValue: item.deliveryFeeValue || item.deliveryfeevalue || 0,
      deliveryfeevalue: item.deliveryfeevalue || item.deliveryFeeValue || 0,

      // Opening hours
      isActive: item.isActive ?? item.IsActive ?? true,
      openingTime: item.openingTime || item.OpeningTime,
      closingTime: item.closingTime || item.ClosingTime,

      // Images
      ImageUrl: item.ImageUrl || item.imageUrl || item.Image || item.image || '',
      imageUrl: item.imageUrl || item.ImageUrl || item.Image || item.image || '',
      Image: item.Image || item.image || item.ImageUrl || item.imageUrl || '',
      image: item.image || item.Image || item.ImageUrl || item.imageUrl || '',

      // Social Media
      facebookUrl: item.facebookUrl || item.FacebookUrl || '',
      FacebookUrl: item.FacebookUrl || item.facebookUrl || '',
      instagramUrl: item.instagramUrl || item.InstagramUrl || '',
      InstagramUrl: item.InstagramUrl || item.instagramUrl || '',

      Filters: item.Filters || item.filters || [],
      description: item.description || item.Description || '',
      Description: item.Description || item.description || '',
      phoneNumber: item.phoneNumber || item.PhoneNumber || '',
      PhoneNumber: item.PhoneNumber || item.phoneNumber || '',

      displayOrder: item.DisplayOrder ?? item.displayOrder ?? 999999,
      DisplayOrder: item.DisplayOrder ?? item.displayOrder ?? 999999,
      isFeatured: item.IsFeatured ?? item.isFeatured ?? true,
      IsFeatured: item.IsFeatured ?? item.isFeatured ?? true,

      averageRating: item.AverageRating ?? item.averageRating ?? 0,
      AverageRating: item.AverageRating ?? item.averageRating ?? 0,
      totalRatings: item.TotalRatings ?? item.totalRatings ?? 0,
      TotalRatings: item.TotalRatings ?? item.totalRatings ?? 0,

      totalLikes: item.TotalLikes ?? item.totalLikes ?? 0,
      TotalLikes: item.TotalLikes ?? item.totalLikes ?? 0,
      totalDislikes: item.TotalDislikes ?? item.totalDislikes ?? 0,
      TotalDislikes: item.TotalDislikes ?? item.totalDislikes ?? 0,

      DeliveryCities: item.DeliveryCities || item.deliveryCities || [],
      ConnectedBranches: item.ConnectedBranches || item.connectedBranches || [],
    }));
  } catch (error) {
    console.error('Error fetching featured branches:', error);
    throw error;
  }
};

// ==================== 🆕 BRANCH CONNECTIONS ====================

export const fetchBranchConnections = async (branchId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/Branches/${branchId}/connections`);
    return response.data || [];
  } catch (error) {
    console.error(`Error fetching connections for branch ${branchId}:`, error);
    return [];
  }
};

// ==================== 🆕 RATINGS ====================

export const submitBranchRating = async (branchId, { userId, rating, comment }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/Branches/${branchId}/ratings`, {
      userId,
      rating,
      comment,
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting branch rating:', error);
    throw error;
  }
};

export const fetchBranchRatings = async (branchId, page = 1, limit = 20) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/Branches/${branchId}/ratings`, {
      params: { page, limit },
    });
    return response.data; // { ratings, stats, pagination }
  } catch (error) {
    console.error('Error fetching branch ratings:', error);
    throw error;
  }
};

export const fetchUserRatingForBranch = async (branchId, userId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/Branches/${branchId}/ratings/user/${userId}`
    );
    return response.data; // { hasRated, rating }
  } catch (error) {
    console.error('Error fetching user rating:', error);
    throw error;
  }
};

export const deleteBranchRating = async (branchId, userId) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/Branches/${branchId}/ratings/user/${userId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting branch rating:', error);
    throw error;
  }
};

// ==================== 🆕 LIKES / DISLIKES ====================

export const toggleBranchLike = async (branchId, { userId, type }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/Branches/${branchId}/likes`, {
      userId,
      type,
    });
    return response.data; // { message, action, userStatus, branchStats }
  } catch (error) {
    console.error('Error toggling branch like:', error);
    throw error;
  }
};

export const fetchBranchLikes = async (branchId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/Branches/${branchId}/likes`);
    return response.data; // { likes, dislikes }
  } catch (error) {
    console.error('Error fetching branch likes:', error);
    throw error;
  }
};

export const fetchUserLikeForBranch = async (branchId, userId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/Branches/${branchId}/likes/user/${userId}`
    );
    return response.data; // { hasInteracted, type }
  } catch (error) {
    console.error('Error fetching user like status:', error);
    throw error;
  }
};